// Mock data for Charter Roofings website

export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      projects: 'Projects',
      about: 'About Us',
      sponsorship: 'Sponsorship',
      contact: 'Contact',
      getQuote: 'Get a Quote',
    },
    hero: {
      title: 'PREMIUM ROOFING',
      subtitle: 'SOLUTIONS',
      description: 'Charter Roofings delivers exceptional commercial and industrial roofing services across the Netherlands. British expertise, Dutch precision.',
      cta: 'Request Quote',
      secondary: 'View Projects',
    },
    services: {
      title: 'OUR SERVICES',
      subtitle: 'Comprehensive roofing solutions for large-scale commercial and industrial projects',
      items: [
        {
          title: 'Commercial Roofing',
          description: 'Complete roofing systems for offices, retail centers, and commercial buildings. Durable, weather-resistant solutions.',
          icon: 'Building2',
        },
        {
          title: 'Industrial Roofing',
          description: 'Heavy-duty roofing for warehouses, factories, and distribution centers. Built to withstand demanding environments.',
          icon: 'Warehouse',
        },
        {
          title: 'Roof Maintenance',
          description: 'Scheduled maintenance programs to extend roof lifespan and prevent costly repairs. 24/7 emergency service available.',
          icon: 'Wrench',
        },
        {
          title: 'Roof Repairs',
          description: 'Fast, reliable repair services for leaks, damage, and wear. Minimize downtime with our rapid response team.',
          icon: 'Shield',
        },
        {
          title: 'Flat Roofing',
          description: 'Specialist flat roof installation and repairs using modern materials and proven techniques.',
          icon: 'Layers',
        },
        {
          title: 'Roof Tiles',
          description: 'Professional tile roofing installation and repairs. Traditional and modern tile roofing solutions for lasting protection.',
          icon: 'Layers',
        },
      ],
    },
    projects: {
      title: 'FEATURED PROJECTS',
      subtitle: 'Delivering excellence across the Netherlands',
      items: [
        {
          title: 'Van der Valk Laundry Facility',
          location: 'Den Helder, NL',
          size: '10,000 m²',
          type: 'Commercial Flat Roof',
          description: 'Large-scale commercial roofing project for Van der Valk\'s laundry supplier with complete flat roof system.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/bssajw9h_ac7f65fe-de04-4c38-8b0d-ec21cc14366b.jpeg',
        },
        {
          title: 'Google Data Center',
          location: 'Groningen, NL',
          size: '3,000 m²',
          type: 'Industrial Flat Roof',
          description: 'High-specification roofing installation for Google\'s data center with precision engineering.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/mcsppgr3_IMG_4615.jpeg',
        },
        {
          title: 'Space Station Amsterdam',
          location: 'Amsterdam, NL',
          size: '400 m²',
          type: 'Commercial Roofing',
          description: 'Professional roofing solution for Amsterdam\'s creative workspace hub.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/hev00vim_7334C448-3AAE-45DE-A07F-3E367653D833.jpeg',
        },
        {
          title: 'Heineken Factory',
          location: 'Amsterdam Central, NL',
          size: '250 m²',
          type: 'EPDM Flat Roof',
          description: 'Premium EPDM roofing system installed for Heineken production facility in Amsterdam.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/6bdirbmw_IMG_9913.jpeg',
        },
        {
          title: 'Amsterdam Central New Builds',
          location: 'Amsterdam Central, NL',
          size: '200 m²',
          type: 'New Build Roofing',
          description: 'Complete roofing installation for new residential construction in Amsterdam Central.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/lx8bc8tq_IMG_6982.jpeg',
        },
        {
          title: 'Commercial Roofing Project',
          location: 'Netherlands',
          size: 'Various',
          type: 'Commercial Flat Roof',
          description: 'Professional commercial roofing installation with modern materials and techniques.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/njnn6ccj_IMG_8816.jpeg',
        },
      ],
    },
    maintenance: {
      title: 'ROOF MAINTENANCE CONTRACTS',
      subtitle: 'Protect your investment with professional roof maintenance',
      description: 'Regular roof maintenance is essential to extend the lifespan of your roof, prevent costly repairs, and maintain warranty coverage. Our maintenance contracts ensure your roof receives professional care year-round, catching small issues before they become major problems. Studies show that regular maintenance can extend your roof\'s life by up to 50% and save thousands in emergency repairs.',
      cancellation: 'Contracts can only be cancelled within the first 30 days. After this period, the contract remains active for the full term.',
      contracts: [
        {
          title: '1 Year Contract',
          price: '€79.99',
          period: 'per year',
          duration: '1 Year',
          services: [
            'Annual comprehensive roof report',
            'Gutter cleaning (2x per year)',
            'Flat roof debris clearing',
            'Professional roof inspection',
            'Priority emergency response',
            'Warranty documentation',
          ],
        },
        {
          title: '2 Year Contract',
          price: '€119.99',
          period: 'per year',
          duration: '2 Years',
          popular: true,
          savings: 'Save €40',
          services: [
            'Annual comprehensive roof report',
            'Gutter cleaning (2x per year)',
            'Flat roof debris clearing',
            'Professional roof inspection',
            'Priority emergency response',
            'Warranty documentation',
            'Minor repairs included (up to €200)',
          ],
        },
        {
          title: '3 Year Contract',
          price: '€149.99',
          period: 'per year',
          duration: '3 Years',
          savings: 'Save €90',
          services: [
            'Annual comprehensive roof report',
            'Gutter cleaning (2x per year)',
            'Flat roof debris clearing',
            'Professional roof inspection',
            'Priority emergency response',
            'Warranty documentation',
            'Minor repairs included (up to €300)',
            'Free emergency call-outs',
          ],
        },
      ],
      oneOff: {
        title: 'One-Off Roof Inspection',
        price: '€149.99',
        description: 'Comprehensive single roof inspection with detailed report',
        services: [
          'Complete roof inspection',
          'Detailed condition report',
          'Photo documentation',
          'Repair recommendations',
          'No long-term commitment',
        ],
      },
      whyImportant: {
        title: 'Why Roof Maintenance is Essential',
        reasons: [
          'Extends roof lifespan by up to 50%',
          'Prevents costly emergency repairs',
          'Maintains warranty validity',
          'Early detection of potential issues',
          'Protects building interior from water damage',
          'Maintains property value',
        ],
      },
    },
    certifications: {
      title: 'CERTIFICATIONS & STANDARDS',
      subtitle: 'Committed to excellence and safety',
      items: [
        'ISO 9001:2015 Certified',
        'VCA** Safety Certified',
        'NEN 6707 Compliant',
        '10 Year Warranty',
        'Fully Insured',
        'British Standards BS 8000',
      ],
    },
    about: {
      title: 'ABOUT CHARTER ROOFINGS',
      subtitle: 'British expertise meets Dutch precision',
      description: 'Charter Roofings is a British roofing company based in the Netherlands, bringing over a decade of commercial and industrial roofing excellence. We combine British craftsmanship with Dutch efficiency to deliver premium roofing solutions for large-scale projects across the Netherlands.',
      stats: [
        { number: '10+', label: 'Years Experience' },
        { number: '500+', label: 'Projects Completed' },
        { number: '2M+', label: 'm² Roofing Installed' },
        { number: '100%', label: 'Client Satisfaction' },
      ],
    },
    sponsorship: {
      title: 'OUR SPONSORSHIP',
      subtitle: 'Supporting excellence on and off the track',
      championName: 'Nikki Coates',
      championTitle: 'British Superbike Champion',
      description: 'Charter Roofings is proud to sponsor Nikki Coats, British Superbike Champion. Just like our roofing work, Nikki represents precision, reliability, and peak performance. We believe in supporting champions who share our commitment to excellence.',
      quote: '"Charter Roofings\' support has been incredible. Their commitment to quality matches my approach to racing - always striving for the best."',
    },
    quote: {
      title: 'REQUEST A QUOTE',
      subtitle: 'Get a free, no-obligation quote for your project',
      form: {
        companyName: 'Company Name',
        contactName: 'Contact Person',
        email: 'Email Address',
        phone: 'Phone Number',
        projectType: 'Project Type',
        projectSize: 'Estimated Size (m²)',
        location: 'Project Location',
        message: 'Project Details',
        submit: 'Submit Quote Request',
        projectTypes: [
          'Commercial Roofing',
          'Industrial Roofing',
          'Roof Maintenance',
          'Roof Repairs',
          'Flat Roofing',
          'Roof Tiles',
        ],
      },
      success: 'Thank you! We\'ll contact you within 24 hours.',
    },
    contact: {
      title: 'CONTACT US',
      subtitle: 'Get in touch with our team',
      address: 'Charter Roofings Netherlands',
      location: 'Terneuzen, Netherlands',
      phone: '+31 6 2337 0072',
      email: 'charterroofings@gmail.com',
      hours: 'Mon-Fri: 8:00 - 18:00',
      emergency: '24/7 Emergency Service',
    },
    footer: {
      tagline: 'Premium roofing solutions for commercial and industrial projects',
      copyright: '© 2025 Charter Roofings. All rights reserved.',
      links: {
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
      },
    },
  },
  nl: {
    nav: {
      home: 'Home',
      services: 'Diensten',
      projects: 'Projecten',
      about: 'Over Ons',
      sponsorship: 'Sponsoring',
      contact: 'Contact',
      getQuote: 'Offerte Aanvragen',
    },
    hero: {
      title: 'PREMIUM DAKWERK',
      subtitle: 'OPLOSSINGEN',
      description: 'Charter Roofings levert uitzonderlijke commerciële en industriële dakwerkdiensten in heel Nederland. Britse expertise, Nederlandse precisie.',
      cta: 'Offerte Aanvragen',
      secondary: 'Bekijk Projecten',
    },
    services: {
      title: 'ONZE DIENSTEN',
      subtitle: 'Uitgebreide dakoplossingen voor grootschalige commerciële en industriële projecten',
      items: [
        {
          title: 'Commercieel Dakwerk',
          description: 'Complete daksystemen voor kantoren, winkelcentra en commerciële gebouwen. Duurzame, weerbestendige oplossingen.',
          icon: 'Building2',
        },
        {
          title: 'Industrieel Dakwerk',
          description: 'Heavy-duty dakwerk voor magazijnen, fabrieken en distributiecentra. Gebouwd om veeleisende omgevingen te weerstaan.',
          icon: 'Warehouse',
        },
        {
          title: 'Dakonderhoud',
          description: 'Geplande onderhoudsprogramma\'s om de levensduur van uw dak te verlengen. 24/7 noodservice beschikbaar.',
          icon: 'Wrench',
        },
        {
          title: 'Dakreparaties',
          description: 'Snelle, betrouwbare reparatiediensten voor lekken, schade en slijtage. Minimaliseer downtime met ons snelle-responsteam.',
          icon: 'Shield',
        },
        {
          title: 'Platte Daken',
          description: 'Specialist in plat dak installatie en reparaties met moderne materialen en bewezen technieken.',
          icon: 'Layers',
        },
        {
          title: 'Dakpannen',
          description: 'Professionele installatie en reparatie van dakpannen. Traditionele en moderne dakpannenoplossingen voor duurzame bescherming.',
          icon: 'Layers',
        },
      ],
    },
    projects: {
      title: 'UITGELICHTE PROJECTEN',
      subtitle: 'Excellence leveren door heel Nederland',
      items: [
        {
          title: 'Van der Valk Wasserij Faciliteit',
          location: 'Den Helder, NL',
          size: '10.000 m²',
          type: 'Commercieel Plat Dak',
          description: 'Grootschalig commercieel dakproject voor de wasserij leverancier van Van der Valk met compleet plat dak systeem.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/bssajw9h_ac7f65fe-de04-4c38-8b0d-ec21cc14366b.jpeg',
        },
        {
          title: 'Google Datacenter',
          location: 'Groningen, NL',
          size: '3.000 m²',
          type: 'Industrieel Plat Dak',
          description: 'Hoogwaardige dakinstallatie voor Google\'s datacenter met precisie engineering.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/mcsppgr3_IMG_4615.jpeg',
        },
        {
          title: 'Space Station Amsterdam',
          location: 'Amsterdam, NL',
          size: '400 m²',
          type: 'Commercieel Dakwerk',
          description: 'Professionele dakoplossing voor Amsterdam\'s creatieve werkruimte hub.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/hev00vim_7334C448-3AAE-45DE-A07F-3E367653D833.jpeg',
        },
        {
          title: 'Heineken Fabriek',
          location: 'Amsterdam Centrum, NL',
          size: '250 m²',
          type: 'EPDM Plat Dak',
          description: 'Premium EPDM daksysteem geïnstalleerd voor Heineken productiefaciliteit in Amsterdam.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/6bdirbmw_IMG_9913.jpeg',
        },
        {
          title: 'Amsterdam Centrum Nieuwbouw',
          location: 'Amsterdam Centrum, NL',
          size: '200 m²',
          type: 'Nieuwbouw Dakwerk',
          description: 'Volledige dakinstallatie voor nieuwe woningbouw in Amsterdam Centrum.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/lx8bc8tq_IMG_6982.jpeg',
        },
        {
          title: 'Commercieel Dakwerk Project',
          location: 'Nederland',
          size: 'Variabel',
          type: 'Commercieel Plat Dak',
          description: 'Professionele commerciële dakinstallatie met moderne materialen en technieken.',
          image: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/njnn6ccj_IMG_8816.jpeg',
        },
      ],
    },
    maintenance: {
      title: 'DAKONDERHOUD CONTRACTEN',
      subtitle: 'Bescherm uw investering met professioneel dakonderhoud',
      description: 'Regelmatig dakonderhoud is essentieel om de levensduur van uw dak te verlengen, kostbare reparaties te voorkomen en garantiedekking te behouden. Onze onderhoudscontracten zorgen ervoor dat uw dak het hele jaar door professionele zorg ontvangt en kleine problemen worden opgespoord voordat ze grote problemen worden. Studies tonen aan dat regelmatig onderhoud de levensduur van uw dak met maximaal 50% kan verlengen en duizenden aan noodreparaties kan besparen.',
      cancellation: 'Contracten kunnen alleen binnen de eerste 30 dagen worden geannuleerd. Na deze periode blijft het contract actief voor de volledige looptijd.',
      contracts: [
        {
          title: '1 Jaar Contract',
          price: '€79,99',
          period: 'per jaar',
          duration: '1 Jaar',
          services: [
            'Jaarlijks uitgebreid dakrapport',
            'Dakgoot reiniging (2x per jaar)',
            'Plat dak debris verwijdering',
            'Professionele dakinspectie',
            'Prioriteit noodrespons',
            'Garantiedocumentatie',
          ],
        },
        {
          title: '2 Jaar Contract',
          price: '€119,99',
          period: 'per jaar',
          duration: '2 Jaar',
          popular: true,
          savings: 'Bespaar €40',
          services: [
            'Jaarlijks uitgebreid dakrapport',
            'Dakgoot reiniging (2x per jaar)',
            'Plat dak debris verwijdering',
            'Professionele dakinspectie',
            'Prioriteit noodrespons',
            'Garantiedocumentatie',
            'Kleine reparaties inbegrepen (tot €200)',
          ],
        },
        {
          title: '3 Jaar Contract',
          price: '€149,99',
          period: 'per jaar',
          duration: '3 Jaar',
          savings: 'Bespaar €90',
          services: [
            'Jaarlijks uitgebreid dakrapport',
            'Dakgoot reiniging (2x per jaar)',
            'Plat dak debris verwijdering',
            'Professionele dakinspectie',
            'Prioriteit noodrespons',
            'Garantiedocumentatie',
            'Kleine reparaties inbegrepen (tot €300)',
            'Gratis noodoproepen',
          ],
        },
      ],
      oneOff: {
        title: 'Eenmalige Dakinspectie',
        price: '€149,99',
        description: 'Uitgebreide enkele dakinspectie met gedetailleerd rapport',
        services: [
          'Volledige dakinspectie',
          'Gedetailleerd conditierapport',
          'Foto documentatie',
          'Reparatie aanbevelingen',
          'Geen langetermijnverplichting',
        ],
      },
      whyImportant: {
        title: 'Waarom Dakonderhoud Essentieel is',
        reasons: [
          'Verlengt de levensduur van het dak met maximaal 50%',
          'Voorkomt kostbare noodreparaties',
          'Behoudt garantiegeldigheid',
          'Vroege detectie van potentiële problemen',
          'Beschermt gebouwinterieur tegen waterschade',
          'Behoudt vastgoedwaarde',
        ],
      },
    },
    certifications: {
      title: 'CERTIFICERINGEN & NORMEN',
      subtitle: 'Toegewijd aan excellentie en veiligheid',
      items: [
        'ISO 9001:2015 Gecertificeerd',
        'VCA** Veiligheid Gecertificeerd',
        'NEN 6707 Conform',
        '10 Jaar Garantie',
        'Volledig Verzekerd',
        'British Standards BS 8000',
      ],
    },
    about: {
      title: 'OVER CHARTER ROOFINGS',
      subtitle: 'Britse expertise ontmoet Nederlandse precisie',
      description: 'Charter Roofings is een Brits dakbedrijf gevestigd in Nederland, met meer dan tien jaar ervaring in commercieel en industrieel dakwerk. Wij combineren Brits vakmanschap met Nederlandse efficiëntie om premium dakoplossingen te leveren voor grootschalige projecten door heel Nederland.',
      stats: [
        { number: '10+', label: 'Jaar Ervaring' },
        { number: '500+', label: 'Voltooide Projecten' },
        { number: '2M+', label: 'm² Geïnstalleerd Dakwerk' },
        { number: '100%', label: 'Klanttevredenheid' },
      ],
    },
    sponsorship: {
      title: 'ONZE SPONSORING',
      subtitle: 'Excellentie ondersteunen op en naast de baan',
      championName: 'Nikki Coates',
      championTitle: 'British Superbike Kampioen',
      description: 'Charter Roofings is trots om Nikki Coats te sponsoren, British Superbike Kampioen. Net als ons dakwerk vertegenwoordigt Nikki precisie, betrouwbaarheid en topprestaties. Wij geloven in het ondersteunen van kampioenen die onze toewijding aan excellentie delen.',
      quote: '"De steun van Charter Roofings is ongelooflijk geweest. Hun toewijding aan kwaliteit komt overeen met mijn benadering van racen - altijd streven naar het beste."',
    },
    quote: {
      title: 'OFFERTE AANVRAGEN',
      subtitle: 'Ontvang een gratis, vrijblijvende offerte voor uw project',
      form: {
        companyName: 'Bedrijfsnaam',
        contactName: 'Contactpersoon',
        email: 'E-mailadres',
        phone: 'Telefoonnummer',
        projectType: 'Projecttype',
        projectSize: 'Geschatte Grootte (m²)',
        location: 'Projectlocatie',
        message: 'Projectdetails',
        submit: 'Offerte Aanvraag Versturen',
        projectTypes: [
          'Commercieel Dakwerk',
          'Industrieel Dakwerk',
          'Dakonderhoud',
          'Dakreparaties',
          'Platte Daken',
          'Dakpannen',
        ],
      },
      success: 'Dank u! We nemen binnen 24 uur contact met u op.',
    },
    contact: {
      title: 'CONTACT',
      subtitle: 'Neem contact op met ons team',
      address: 'Charter Roofings Nederland',
      location: 'Terneuzen, Nederland',
      phone: '+31 6 2337 0072',
      email: 'charterroofings@gmail.com',
      hours: 'Ma-Vr: 8:00 - 18:00',
      emergency: '24/7 Noodservice',
    },
    footer: {
      tagline: 'Premium dakoplossingen voor commerciële en industriële projecten',
      copyright: '© 2025 Charter Roofings. Alle rechten voorbehouden.',
      links: {
        privacy: 'Privacybeleid',
        terms: 'Servicevoorwaarden',
      },
    },
  },
};

export const heroImages = {
  main: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/5k6lof02_IMG_0331.jpeg',
  alt1: 'https://images.pexels.com/photos/8853523/pexels-photo-8853523.jpeg',
  alt2: 'https://images.pexels.com/photos/2317640/pexels-photo-2317640.jpeg',
};

export const additionalImages = {
  roofingWork: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/e6lijggu_IMG_0330.jpeg',
};

export const serviceImages = {
  commercial: 'https://images.unsplash.com/photo-1715191620078-300049efa179',
  industrial: 'https://images.pexels.com/photos/1890416/pexels-photo-1890416.jpeg',
  maintenance: 'https://images.unsplash.com/photo-1759244565928-203a7fb00a29',
  repairs: 'https://images.unsplash.com/photo-1657195721935-e73e545a2aae',
  flat: 'https://images.unsplash.com/photo-1654848232800-20fbc9cdbc10',
  solar: 'https://images.pexels.com/photos/31763537/pexels-photo-31763537.jpeg',
};

export const sponsorshipImages = {
  nikki1: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/3fl3gnqk_IMG_6491.jpeg',
  nikki2: 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/5u1tri6b_IMG_6486.jpeg',
};

export const companyLogo = 'https://customer-assets.emergentagent.com/job_dutch-roofers/artifacts/zhd6t8ly_IMG_4430.png';
